import styled from '@emotion/styled'
import { colors, space, type } from '@workday/canvas-kit-react/tokens'
import { TableRow, TableRowProps } from '@workday/canvas-kit-react'

export const PPTableRow = styled(TableRow)<TableRowProps>(
  {},
  ({ header }) => {
    if (header) {
      return {
        'th, td': {
          ...type.levels.subtext.large,
          backgroundColor: colors.soap200,
          height: space.xxl,
          fontWeight: 700
        },
        '&:hover': {
          'th, td': {
            backgroundColor: colors.soap200
          }
        }
      }
    } else {
      return {
        'th, td': {
          ...type.levels.subtext.large
        },
        '&:hover': {
          'th, td': {
            backgroundColor: colors.frenchVanilla100
          }
        }
      }
    }
  },
  ({ state }) => {
    return {}
  }
)
